import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';
import { useJsonLd } from '@/hooks/useJsonLd';
import { faqs } from '@/mocks/data';

export default function Home() {
  useEffect(() => {
    document.title = '亚洲一级日本精选内容导航平台 | 顶级日本文化资源导航';
  }, []);

  useJsonLd({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': 'https://z3ratu1.cn/#organization',
        name: '亚洲一级日本精选内容导航平台',
        url: 'https://z3ratu1.cn/',
        slogan: '汇聚亚洲精华，精选日本一级内容',
        description: '亚洲一级日本频道汇聚顶级亚洲与日本优质内容资源，提供专业分级导航与精准内容推荐。',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'contact@asia-japan-premium.com',
          contactType: 'customer service',
          availableLanguage: ['Chinese', 'Japanese'],
        },
      },
      {
        '@type': 'WebSite',
        '@id': 'https://z3ratu1.cn/#website',
        url: 'https://z3ratu1.cn/',
        name: '亚洲一级日本精选内容导航平台',
        inLanguage: 'zh-CN',
        publisher: { '@id': 'https://z3ratu1.cn/#organization' },
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://z3ratu1.cn/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'FAQPage',
        '@id': 'https://z3ratu1.cn/#faq',
        mainEntity: faqs.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
    ],
  });

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}